package game

import EntityDef
import Item
import ShardDoor
import Teleport
import game.controller.FadeToWhite
import game.entity.*

val factories = mapOf(
    "arrow-trap" to { ArrowTrap() },
    "boss-1" to { ImpSpawnPoolBattle() },
    "boulder-1" to { Boulder("boulder-1", 1) },
    "boulder-2" to { Boulder("boulder-2", 2) },
    "bubbles" to { Bubbles() },
    "cactus" to { Cactus(1, "cactus") },
    "door" to { Door() },
    "end-father" to { EndFather() },
    "end-portal" to { EndPortal() },
    "ice-cactus" to { Cactus(3, "ice-cactus") },
    "troll-cactus" to { Cactus(5, "troll-cactus") },
    "cobbler-battle" to { CobblerBattle() },
    "fade-to-white" to { ScriptNpc(null,  false, listOf(
        {
            it.controller = FadeToWhite()
            it.controller
        }
    ))},
    "father-1" to {
        ScriptNpc(
            "npc-dark-red", false, listOf(
                { it.showDialog("Npc_Wishlair1") },
                { it.startTeleportTransition(it.player.col, it.player.row, ROOM_WIDTH - 2, 10, "pong-battle", true) },
            )
        )
    },
    "ghost-1" to { Ghost(GhostLevel.Ghost1) },
    "ghost-2" to { Ghost(GhostLevel.Ghost2) },
    "ghost-3" to { Ghost(GhostLevel.Ghost3) },
    "heart-container" to { HeartContainer() },
    "heal-station" to { HealStation() },
    "hunter" to { Hunter(1, 1, "imp") },
    "item" to { Item() },
    "imp" to { Imp(ImpType.GreyImp) },
    "kraken-battle" to { KrakenBattle() },
    "large-shard" to { Shard(ShardValue.Large) },
    "lobby-trap" to { LobbyTrap() },
    "lore" to { Lore() },
    "maze-battle" to { MazeBattle() },
    "maze-shard" to { MazeShard() },
    "medium-shard" to { Shard(ShardValue.Medium) },
    "mushroom" to { Walker() },
    "nessy-ground-1" to { Nessy("grey-ground-nessy", "ground-bubble", "red-mucus-ball", TileType.Floor, 2, 1) },
    "nessy-ground-2" to { Nessy("red-ground-nessy", "ground-bubble", "red-mucus-ball", TileType.Floor, 4, 4) },
    "nessy-water-1" to { Nessy("blue-water-nessy", "bubble", "red-mucus-ball", TileType.Water, 1, 1) },
    "nessy-water-2" to { Nessy("red-water-nessy", "bubble", "red-mucus-ball", TileType.Water, 3, 2) },
    "nessy-lava-1" to { Nessy("lava-nessy", "lava-bubble", "red-mucus-ball", TileType.Lava, 3, 2) },
    "npc-dark-red" to { Npc("npc-dark-red", false) },
    "npc-blue-imp" to { Npc("npc-blue-imp", true) },
    "npc-red" to { Npc("npc-red", false) },
    "npc-red-wander" to { Npc("npc-red", true) },
    "npc-blue" to { Npc("npc-blue", false) },
    "npc-blue-wander" to { Npc("npc-blue", true) },
    "npc-green" to { Npc("npc-green", false) },
    "npc-green-wander" to { Npc("npc-green", true) },
    "npc-cyan" to { Npc("npc-cyan", false) },
    "npc-cyan-wander" to { Npc("npc-cyan", true) },
    "final-pong-battle" to { FinalPongBattle() },
    "pot-1" to { Pot(PotLevel.Level1) },
    "pot-2" to { Pot(PotLevel.Level2) },
    "red-imp" to { Imp(ImpType.RedImp) },
    "rink-battle" to { RinkBattle() },
    "shard-door" to { ShardDoor() },
    "small-shard" to { Shard(ShardValue.Small) },
    "spawner" to { Spawner() },
    "teleport" to { Teleport() },
    "tip-message" to { TipMessage() },
    "trunk-maze-battle" to { TrunkMazeBattle() },
    "blue-worm" to { Worm(2, 1, "blue-worm", 0.2) },
    "ice-worm" to { Worm(4, 2, "ice-worm", 0.2, TileType.Ice) },
    "red-worm" to { Worm(5, 3, "red-worm", 0.2, TileType.Lava) },
    "test-box" to { TestBox() }
)

fun createEntity(def: EntityDef): Entity {
    val factory = factories[def.type]

    val entity = if (factory != null) factory() else throw Exception("Unknown entity type: ${def.type}")

    entity.id = def.id
    entity.type = def.type
    entity.col = def.col
    entity.row = def.row
    entity.width = def.width
    entity.height = def.height
    entity.params = def.params
    entity.tag = def.tag

    return entity
}
